import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GenericFormService } from 'form-elements';
import { ModalBoxService } from 'modal-box';
import { CheckList } from 'src/app/models/winco/check-list.model';

@Component({
  selector: 'app-exercise-checklist-edit',
  templateUrl: './exercise-checklist-edit.component.html',
  styleUrl: './exercise-checklist-edit.component.scss'
})
export class ExerciseChecklistEditComponent
{
  item:CheckList | undefined;

  form: FormGroup; //formulario

  oldName:string | undefined;

  constructor(private formBuilder: FormBuilder,
              public genericFormService: GenericFormService,
              private  modalBoxService:ModalBoxService)
  {
    this.form = new FormGroup({});
  }

  /**
   * Se ejecuta la primera vez que se carga la pantalla
   */
  ngOnInit(): void
  {

    this.item = this.modalBoxService.data as CheckList;

    let fields:any;
    let values:any;

    if(this.item.isMilestone)
    {
      fields = {
        description : ['', [ Validators.required, Validators.maxLength(500) ]]
      };

      values = {
        description: this.item.description
      };
    }
    else
    {
      fields = {
        name : ['', [ Validators.required, Validators.maxLength(50) ]],
        description : ['', [ Validators.required, Validators.maxLength(500) ]]
      };

      values = {
        name : this.item.name,
        description: this.item.description
      };
    }

    this.oldName = this.item.name;

    this.form = this.formBuilder.group(fields);

    this.item = this.modalBoxService.data as CheckList;

    (<FormGroup>this.form).setValue(values, {onlySelf: true});
  }

  cancel()
  {
    this.modalBoxService.hide();
  }

/**
   * Se ejecuta cuando se envía el formulario
   * Guarda los datos introducidos en la base de datos
   */
  accept()
  {
    if (this.form.valid)
    {
      this.item.name = this.form.value.name;
      this.item.description = this.form.value.description;

      this.modalBoxService.config.acceptCallback(this.item);
      this.modalBoxService.hide();
    }
    else
    {
      this.genericFormService.validateAllFormFields(this.form);
    }
  }
}
